module.exports = __webpack_public_path__ + "static/media/comfirmBg@2x.07a307fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/comfirmBg@2x.png
// module id = 1223
// module chunks = 0